<markant-dialog
  *ngIf="open"
  [open]="true"
  [critical]="true"
  (close)="closeDialog(false)"
>
  <markant-platform-user-consent-confirmation
    (userConsentsConfirmedChanged)="closeDialog($event)"
  >
  </markant-platform-user-consent-confirmation>
</markant-dialog>
